import { createContext } from 'react';

export const currentPromoLimitContext = createContext<number | null>(null);
